import { useState, useEffect, useCallback } from 'react';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'settings';

/**
 * Minimal hook to load user from storage for TemplateView (contact prefill).
 * Returns { user } where user is the stored user object (may have .response or flat fields).
 */
const useAppStorage = () => {
  const [user, setUser] = useState(null);

  const loadUser = useCallback(async () => {
    try {
      const value = await StorageHandler.load(storageKeys.user);
      setUser(value || null);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return { user };
};

export default useAppStorage;
